var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 51",
    style: {
      enableBackground: "new 0 0 52 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DB0716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,9.94v31.12c0,2.16-0.77,4.26-2.18,5.89c-0.14,0.19-0.34,0.4-0.54,0.6l-0.34,0.29 c-0.04,0.06-0.1,0.11-0.17,0.15c0,0.01-0.06,0.06-0.14,0.11c-0.01,0.01-0.04,0.04-0.08,0.06c-1.54,1.29-3.55,2-5.66,2H9.6 c-5.02,0-9.1-4.08-9.1-9.1V9.94c0-5.02,4.08-9.1,9.1-9.1h8.55v4.85H9.6c-2.35,0-4.26,1.91-4.26,4.25v31.12 c0,2.34,1.91,4.25,4.26,4.25h32.8c2.35,0,4.27-1.91,4.27-4.25V9.94c0-2.34-1.92-4.25-4.27-4.25h-9.89 c-2.35,0-4.26,1.91-4.26,4.25v17l6.61-6.63c0.54-0.46,1.15-0.66,1.77-0.59c0.62,0.05,1.18,0.34,1.56,0.81 c0.74,0.86,0.76,2.11,0.04,2.97l-10.9,10.89c-0.44,0.43-1.03,0.68-1.62,0.68c-0.53,0.05-1.18-0.21-1.65-0.66L13.22,23.57 c-0.44-0.45-0.68-1.03-0.68-1.65c0-0.64,0.25-1.23,0.7-1.66c0.36-0.39,0.94-0.63,1.56-0.64c0.67-0.01,1.26,0.22,1.7,0.64 l6.89,6.92V9.94c0-2.6,1.13-5.09,3.1-6.83c1.65-1.46,3.79-2.27,6.01-2.27h9.89C47.41,0.84,51.5,4.92,51.5,9.94z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.55bcec75c2fb672f5efb7f08d664deed.svg";
export { ForwardRef as ReactComponent };